import { global } from './global';

const url = `${global.managerURL}/data/calendarioricodata`;
// const url = `http://localhost:3000/calendarioescuela.json`;
let cachedData = null;

const fetchCalendarData = async () => {
    if (cachedData) return cachedData;
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch calendar data');
        const data = await response.json();
        cachedData = data;
        return cachedData;
    } catch (error) {
        console.error('Error loading calendar data:', error);
        return [];
    }
};

export const calendariodataescuela = async (variant) => {
	const data = await fetchCalendarData(); // Obtener los datos (usando caché si ya están cargados).
	let dates = [];
	if (variant === 'home') {
	  dates = data;
	} else {
	  dates = variant ? data.filter(item => item.segmento_id === variant) : data;
	}
  
	// Función para transformar la fecha al formato deseado
	const formatDate = dateStr => {
	  const date = new Date(dateStr);
	  return date.toISOString().split('T')[0]; // Convierte a "YYYY-MM-DD"
	};
  
	// Ordenar las fechas
	const parseDate = dateStr => new Date(dateStr);
	dates.sort((a, b) => parseDate(b.fecha) - parseDate(a.fecha));
  
	// Convertir el formato de las fechas antes de devolver
	const formattedDates = dates.map(item => ({
	  ...item,
	  fecha: formatDate(item.fecha),
	}));
  
	return formattedDates;
  };